export default "__VITE_ASSET__DSLGEFWc__"